import Api from "../axios";

export default async function apiManagerEmployees() {
  return await Api.get("/employee_detail_list");
}
